import { render, staticRenderFns } from "./pencil.vue?vue&type=template&id=94169616&"
import script from "./pencil.vue?vue&type=script&lang=js&"
export * from "./pencil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports